Bingo.OfferFilterForm = Bingo.OfferFilterForm || {};
Bingo.OfferFilterForm.statusFilter = {};

Bingo.OfferFilterForm.statusFilter.selector = null;

Bingo.OfferFilterForm.statusFilter.init = function (selector) {
    Bingo.OfferFilterForm.statusFilter.selector = selector;
    Bingo.OfferFilterForm.statusFilter.selector.on('click', function () {
        Bingo.OfferFilterForm.statusFilter.colorize($(this));
    });
    Bingo.OfferFilterForm.statusFilter.selector.each(function () {
        Bingo.OfferFilterForm.statusFilter.colorize($(this));
    });
};

Bingo.OfferFilterForm.statusFilter.colorize = function (selector) {
    if (selector.prop('checked')) {
        selector.closest('.options-item').addClass('active-tool');
    } else {
        selector.closest('.options-item').removeClass('active-tool');
    }
};

Bingo.OfferFilterForm.statusFilter.resetStatusFilters = function () {
    Bingo.OfferFilterForm.statusFilter.selector.each(function () {
        $(this).prop('checked', true);
        Bingo.OfferFilterForm.colorize($(this));
    });
};

Bingo.OfferFilterForm.statusFilter.initFormSubmit = function (buttons) {
    Bingo.OfferFilterForm.statusFilter.selector.on('click', () => {
        if (buttons.length > 0) {
            buttons[0].click();
        }
    });
};
